import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { KaizenService } from '../Services/Kaizen.Service';
@Component({
    selector: 'app-advancedsearch',
    templateUrl: './advancedsearch.component.html',
    styleUrl: './advancedsearch.component.css',
    standalone: false
})
export class AdvancedsearchComponent implements OnInit {
  searchResults: any;

  constructor(private readonly fb: FormBuilder, private readonly kaizenService: KaizenService) { }

  form!: FormGroup;
  searchSummary = '';
  submitted = false;
  loading = false;
  displayedColumns: string[] = [
    'kaizenNumber',
    'company',
    'line',
    'shop',
    'model',
    'savingsImpact',
    'investmentType',
    'name',
    'account',
    'fySavings',
    'state',
    'action'
  ];

  ngOnInit(): void {
    const currentFiscalYear = this.getCurrentFiscalYear();

    this.form = this.fb.group(
      {
        beginningFiscalYear: [currentFiscalYear, Validators.required],
        endingFiscalYear: [null], // optional
        fields: [[], Validators.required],
        criteria: ['', Validators.required]
      },
      { validators: endingGreaterThanBeginningValidator }
    );

    // Revalidate when beginning FY changes
    this.form.get('beginningFiscalYear')?.valueChanges.subscribe(() => {
      this.form.get('endingFiscalYear')?.updateValueAndValidity();
    });
    this.form.get('endingFiscalYear')?.valueChanges.subscribe(() => {
      this.form.updateValueAndValidity({ onlySelf: false });
    });

  }

  getCurrentFiscalYear(): number {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    return month >= 4 ? year + 1 : year;
  }

  submit(): void {
    this.form.get('endingFiscalYear')?.markAsTouched();

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitted = true;
    this.searchSummary = this.buildSearchSummary(this.form.value);

    this.searchResults = [];

    const payload = {
      beginningFiscalYear: this.form.value.beginningFiscalYear,
      endingFiscalYear: this.form.value.endingFiscalYear || null,
      fields: this.form.value.fields,
      criteria: this.form.value.criteria
    };


    this.kaizenService.advancedSearchKaizens(
      payload.beginningFiscalYear,
      payload.endingFiscalYear,
      payload.fields,
      payload.criteria
    ).subscribe({
      next: (response: { data: any[] }) => {
        this.searchResults = response?.data ?? [];
      },
      error: () => {
        this.searchResults = [];
      }
    });
  }

  resetForm(): void {
    const currentFiscalYear = this.getCurrentFiscalYear();

    this.form.reset(
      {
        beginningFiscalYear: currentFiscalYear,
        endingFiscalYear: null,
        fields: [],
        criteria: ''
      },
      { emitEvent: true }
    );
    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.form.updateValueAndValidity();
  }


  private buildSearchSummary(value: any): string {
    const parts: string[] = [];

    if (value.beginningFiscalYear && value.endingFiscalYear) {
      parts.push(
        `Fiscal Year from ${value.beginningFiscalYear} to ${value.endingFiscalYear}`
      );
    } else {
      parts.push(`Fiscal Year starting ${value.beginningFiscalYear}`);
    }

    if (value.fields?.length) {
      parts.push(`Fields: ${value.fields.join(', ')}`);
    }

    if (value.criteria) {
      parts.push(`Criteria: "${value.criteria}"`);
    }

    return `Search performed with ${parts.join('; ')}.`;
  }
}

/* Cross-field validator */
export const endingGreaterThanBeginningValidator: ValidatorFn =
  (group: AbstractControl): ValidationErrors | null => {

    const start = group.get('beginningFiscalYear')?.value;
    const end = group.get('endingFiscalYear')?.value;

    if (start == null) {
      return null;
    }

    if (end == null || end === '') {
      return null;
    }

    return end > start ? null : { fiscalYearInvalid: true };
  };
